/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import hyperlinkTargets from 'bi-report/src/bi/report/jive/enum/hyperlinkTargets';
import dashboardHyperlinkHandlerUtil from './util/dashboardHyperlinkHandlerUtil';

export default {
    events: {
        click: function (ev, link, dashlet) {
            if (!dashlet.model.get('isReplacedHyperlink')) {
                if (dashlet.model.get('exposeOutputsToFilterManager') && link.parameters) {
                    // in case of Open new page/ Replace page its still required to notify wiring to route parameter values
                    // because the url may contain parameters. But this change should not be saved in parameters undo/redo stack
                    if (dashlet.model.get('dashletHyperlinkTarget') && dashlet.model.get('dashletHyperlinkTarget') !== hyperlinkTargets.REPLACE) {
                        try {
                            dashlet.model.collection.disableParametersStateStack();
                            dashlet.notify(link.parameters);
                            dashlet.model.collection.enableParametersStateStack();
                        } catch (error) {
                            dashlet.model.collection.enableParametersStateStack();
                            throw error;
                        }
                    } else if (dashlet.model.get('dashletHyperlinkTarget') === hyperlinkTargets.REPLACE) {
                        dashlet.notify(link.parameters, dashlet.model.get('dashletHyperlinkUrl'), dashlet.model.get('dashletHyperlinkTarget'), dashlet.model.get('dashletHyperlinkUrl').includes("?"));
                    } else {
                        dashlet.notify(link.parameters);
                    }
                }
                if (dashlet.model.get('dashletHyperlinkUrl') && dashlet.model.get('dashletHyperlinkTarget') !== hyperlinkTargets.REPLACE && dashlet.model.get('dashletHyperlinkTarget')) {
                    dashlet.model.getLinkUrl(dashlet.model.paramsModel.attributes).done(function (url) {
                        var hyperlinkN = dashboardHyperlinkHandlerUtil.getUrlParameter(window.location.href, '_ddHyperlink');

                        if (hyperlinkN && +hyperlinkN.value) {
                            hyperlinkN = +hyperlinkN.value;
                        } else {
                            hyperlinkN = 0;
                        }

                        url = dashboardHyperlinkHandlerUtil.setUrlParameter(url, '_ddHyperlink', hyperlinkN + 1);

                        if (dashlet.model.get('dashletHyperlinkTarget') === hyperlinkTargets.BLANK) {
                            url = dashboardHyperlinkHandlerUtil.setUrlParameter(url, 'noReturn', true);
                        }
                        if (dashlet.model.get('dashletHyperlinkTarget') === hyperlinkTargets.SELF) {
                            var inFrameParameter = dashboardHyperlinkHandlerUtil.getUrlParameter(window.location.href, 'viewAsDashboardFrame');
                            if (inFrameParameter && inFrameParameter.value === 'true') {
                                url = dashboardHyperlinkHandlerUtil.setUrlParameter(url, inFrameParameter.name, inFrameParameter.value);
                            }
                            window.location.href = url;
                        } else {
                            window.open(url);
                        }
                    }).fail(function (msg) {
                        dashlet.showErrorDialog(msg);
                    });
                }
            }
        }
    }
};

